var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999091 4.99994H3.99909V14.6799H0.999091V4.99994ZM2.52909 0.189941C2.8728 0.189947 3.20882 0.291749 3.49474 0.482504C3.78066 0.673259 4.00368 0.944422 4.13566 1.26178C4.26765 1.57914 4.30268 1.92849 4.23635 2.26574C4.17002 2.60299 4.00529 2.91304 3.76295 3.15678C3.52061 3.40051 3.2115 3.56702 2.87464 3.63528C2.53777 3.70354 2.18823 3.67051 1.87012 3.54034C1.55201 3.41018 1.27957 3.18872 1.08718 2.90389C0.894793 2.61907 0.791067 2.28365 0.789091 1.93994C0.787773 1.7106 0.831807 1.48326 0.91866 1.271C1.00551 1.05874 1.13347 0.865741 1.29518 0.703106C1.45688 0.540471 1.64914 0.411409 1.8609 0.323341C2.07266 0.235273 2.29975 0.189938 2.52909 0.189941ZM5.91909 4.99994H8.80909V6.31994C9.09838 5.82624 9.5163 5.42035 10.0182 5.14561C10.5202 4.87086 11.0873 4.73756 11.6591 4.75994C14.6591 4.75994 15.2691 6.75994 15.2691 9.36994V14.6799H12.2691V9.99994C12.2691 8.87994 12.2691 7.42994 10.7091 7.42994C9.14909 7.42994 8.90909 8.64994 8.90909 9.90994V14.6999H5.90909L5.91909 4.99994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn1);
export default __webpack_public_path__ + "static/media/LinkedIn1.0393bd4c1bbdd4e3348135f31de0a93f.svg";
export { ForwardRef as ReactComponent };